import { LinkElement } from '../models/link-element.model';
import { LinkGroup } from '../models/link-group.model';
import { Coordinates } from 'src/app/reports/components/report/models/coordinates.model';

export function findAbsolutePosition(htmlElement, group: LinkGroup): Coordinates {
  const rect: DOMRect = htmlElement.getBoundingClientRect();
  const rectContentRef: DOMRect = group.contentRef.getBoundingClientRect();
  const x = (rect.left + group.contentRef.scrollLeft - rectContentRef.left) / group.scale;
  const y = (rect.top + group.contentRef.scrollTop - rectContentRef.top) / group.scale;

  return {
      x,
      y
  };
}

export function getCoordinateFromElement(elm, group: LinkGroup): Coordinates {
  const pos = findAbsolutePosition(elm, group);
  pos.y += (elm.offsetHeight / 2);

  return pos;
}

export function getCoordinateFromMouseEvent(event: MouseEvent, container: Element, scale: number = 1): Coordinates {
  const rectContentRef = container.getBoundingClientRect();
  const x = (event.x + container.scrollLeft - rectContentRef.left) / scale;
  const y = (event.y + container.scrollTop - rectContentRef.top) / scale;

  return {
      x,
      y
  };
}

export function getElementCoordinatesByMouseEvent(link: LinkElement, group: LinkGroup, aditionFactor: number) {
  const coordinates = getCoordinateFromElement(link.element, group),
      event = link.event;

  if (event) {
    const mouseCoordinates  = getCoordinateFromMouseEvent(event, group.contentRef, group.scale);

    const width = link.element.getBoundingClientRect().width;

    if ((coordinates.x + (width / 2)) < mouseCoordinates.x) {
      coordinates.x += width + aditionFactor;
    } else {
      coordinates.x -= aditionFactor;
    }
  }

  return coordinates;
}

export function isClosestElement(coordinates: Coordinates, element: LinkElement, group: LinkGroup): boolean {

  element.coordinates = getCoordinateFromElement(element.element, group);

  const rect: DOMRect = element.element.getBoundingClientRect(),
      width = rect.width / group.scale,
      height = rect.height / group.scale,
      x = coordinates.x - (element.coordinates.x + (width / 2)),
      y = coordinates.y - element.coordinates.y;

  return Math.abs(x) <= (width ) && Math.abs(y) <= (height / 2);
}
